import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { Size } from '../../types';
import { colors, sizes, eventDisplayMap } from '../../styles';
import Icon from './icon';

export interface Props {
  eventType: string;
  className?: string;
  size?: Size;
}

class EventCoin extends React.Component<Props, any> {
  public static defaultProps: Props = {
    size: 'md',
    eventType: 'acceleration',
  };

  render() {
    const { eventType, className, size } = this.props;
    const { kind, icon } = eventDisplayMap[eventType];
    return (
      <div
        className={`${className} ${size}`}
        style={{ background: colors[kind] }}
      >
        <Icon size={size} icon={icon} baseColor={colors.white} />
      </div>
    );
  }
}

export default styled(EventCoin)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 1000px;
  ${sizes.createRules(sizes.coin)};
`;
